export default "1.142.0\n"